export default __webpack_public_path__ + "static/media/Tonic3.9bb0a3e3.webp";